var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_license"},[_c(_vm.licenseComponent,{tag:"Component",attrs:{"year":_vm.year}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }